"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/CampaignPage/Header/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);




var _broadcast = require('shared/selectors/broadcast');
var _hooks = require('web/services/hooks');





var _Header = require('web/components/RightSide/Header');
var _CampaignSettings = require('./CampaignSettings'); var _CampaignSettings2 = _interopRequireDefault(_CampaignSettings);
var _CampaignStatus = require('web/screens/Broadcast/CampaignStatus'); var _CampaignStatus2 = _interopRequireDefault(_CampaignStatus);
var _useArchiveCampaign = require('web/screens/Broadcast/useArchiveCampaign'); var _useArchiveCampaign2 = _interopRequireDefault(_useArchiveCampaign);







const CampaignPageHeader = ({
  campaignKey,
  onEditDetails,
  onExportCampaign,
}) => {
  const campaignName = _hooks.useAppSelector.call(void 0, state => _nullishCoalesce(_broadcast.selectCampaignName.call(void 0, state, campaignKey), () => ( '')))
  const isCampaignArchived = _hooks.useAppSelector.call(void 0, state => !!_broadcast.selectIsCampaignArchived.call(void 0, state, campaignKey))
  const isCampaignActive = _hooks.useAppSelector.call(void 0, state => !!_broadcast.selectIsCampaignActive.call(void 0, state, campaignKey))
  const { onArchive, onUnarchive, confirmModal, archiveBlockedReason } = _useArchiveCampaign2.default.call(void 0, campaignKey)

  return (
  _react2.default.createElement(_Header.RightSideHeader, { className: "campaign-header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}}
    , _react2.default.createElement(_Header.HeaderMobileBackButton, { onClick: _actions2.default.gotoDirectory, __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}} )
    , _react2.default.createElement(_Header.RightSideHeaderHeading, {
      title: campaignName,
      subtitle: _react2.default.createElement(_CampaignStatus2.default, { campaignKey: campaignKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}} ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}
    )
    , _react2.default.createElement(_CampaignSettings2.default, {
      isCampaignArchived: isCampaignArchived,
      onEditDetails: onEditDetails,
      onExportCampaign: onExportCampaign,
      isCampaignActive: isCampaignActive,
      onArchive: onArchive,
      onUnarchive: onUnarchive,
      archiveBlockedReason: archiveBlockedReason, __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}
    )
    ,  confirmModal 
  )
  )
}

exports. default = _react.memo.call(void 0, CampaignPageHeader)
